import catalogModule from '../catalogModule';

function itemsContainerController($log, $scope, catalogConstants) {
    "ngInject";

    $scope.getNumberItemToDisplay = function () {
        if ($scope.library.isFullScreen) {
            return catalogConstants.numberOfSearchItemsForFullScreen;
        }
        const { isSplashPage, numberOfSplashResultsToDisplay } = $scope.library;
        return isSplashPage ? numberOfSplashResultsToDisplay : $scope.searchResultList.length;
    }

    $scope.isInfiniteScrollEnabled = function () {
        const { initialized, isPhone, isCatalogInfiniteScrollEnabledForAll } = $scope.library;
        return initialized && (isPhone || isCatalogInfiniteScrollEnabledForAll);
    }

    $scope.isRegularItemsResultAvailable = function () {
        const { initialized, isPhone, isCatalogInfiniteScrollEnabledForAll } = $scope.library;
        return initialized && !isPhone && !isCatalogInfiniteScrollEnabledForAll;
    }

    $scope.isBreadcrumbsAvailable = function () {
        const { initialized, isPhone } = $scope.library;
        return initialized && !isPhone;

    }

    $scope.pager = {
        loadNextPage: function () {
            const { nextPageCursor, startPaging } = $scope.paginations;
            if (nextPageCursor && !startPaging) {
                $scope.queries.cursor = nextPageCursor;
                $scope.getSearchItems($scope.queries, true);
                $scope.paginations.direction = catalogConstants.pageDirection.next;
                $scope.paginations.startPaging = true;
            }
        },
        loadPreviousPage: function () {
            const { previousPageCursor, startPaging } = $scope.paginations;
            if (previousPageCursor && !startPaging) {
                $scope.queries.cursor = previousPageCursor;
                $scope.getSearchItems($scope.queries, true);
                $scope.paginations.direction = catalogConstants.pageDirection.prev;
                $scope.paginations.startPaging = true;
            }
        },
        canLoadNextPage: function () {
            const { nextPageCursor, startPaging } = $scope.paginations;
            return nextPageCursor && !startPaging;
        },
        canLoadPreviousPage: function () {
            const { previousPageCursor, startPaging } = $scope.paginations;
            return previousPageCursor && !startPaging;
        },
        getCurrentPageNumber: function () {
            return $scope.paginations.currentPage;
        }
    };
}

catalogModule.controller("itemsContainerController", itemsContainerController);

export default itemsContainerController;